import { React, useState, useEffect } from "react";
import Modal from "react-modal";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase";
import { auth } from "../firebase";
import scan from "../assets/images/add-image.png";
import { useTranslation } from "react-i18next";
import { BiImageAdd, BiUpload } from "react-icons/bi";
import toast from "react-hot-toast";

Modal.setAppElement("#root");

const Question = ({
  showUpload = null,
  isNBSP = false,
  questID = null,
  question = [],
  onAnswer = null,
  onPrev = null,
  onSubmit = null,
  state: [value = [], setValue],
  radio = false,
  options = [],
  loading = false,
  label = [],
  suggestion = true,
  dropdown = null,
  limit,
}) => {
  const uid = auth.currentUser?.uid;
  const year = process.env.REACT_APP_CURRENT_YEAR;
  const [nbspURL0, setNBSPURL0] = useState(null);
  const [nbspURL1, setNBSPURL1] = useState(null);
  const { t } = useTranslation();
  const [uploadedFileUrl, setUploadedFileUrl] = useState(null);

  const email = auth.currentUser?.email;
  const [pan, setPan] = useState("");

  useEffect(() => {
    setPan(getPan(email));
  }, [email]);

  const getPan = (email) => {
    if (email) {
      let temppan = email.split("+");
      temppan = temppan[1].split("@");
      return temppan[0];
    }
    return null;
  };

  const handleFileUpload = async () => {
    const fileNames = {
      0: "gross",
      1: "Income from Rent sources",
      2: "80C",
      3: "Income from other sources",
      4: "80C",
      5: "80CCD",
      6: "80D",
      7: "80DD",
      8: "80DDB",
      9: "80G",
      10: "80GG",
      11: "OtherEmp",
      12: "costTourAllowance",
      13: "childEduAllowance",
      14: "rentAllowance",
      15: "travelAllowance", // Fixed: was "Travel Allowance"
      16: "otherAllowance",
      17: "Interest on HomeLoan",
      18: "80U",
      19: "80tta",
    };
    const id = Number(questID);
    const fileName = fileNames[id];

    if (selectedFile && uid && fileName) {
      setIsLoading(true);
      const storageRef = ref(
        storage,
        `userDocs/AY-${year}/${pan.toUpperCase()}/` + fileName
      );
      try {
        await uploadBytes(storageRef, selectedFile);
        const fileUrl = await getDownloadURL(storageRef);

        // Store the uploaded file URL
        // Use consistent storage key format
        const storageKey = `uploadedFileUrl_${questID}`;
        localStorage.setItem(storageKey, fileUrl);
        setUploadedFileUrl(fileUrl);

        setIsLoading(false);
        togglePopup();
        toast.success("File uploaded successfully!");
      } catch (error) {
        console.error("Error uploading file: ", error);
        toast.error("Error uploading file: " + error.message);
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    const storedFileUrl = localStorage.getItem(`uploadedFileUrl_${questID}`);
    if (storedFileUrl) {
      setUploadedFileUrl(storedFileUrl);
    }
  }, [questID]);

  const [message, setmessage] = useState("");
  const newmessage = (value) => {
    setmessage(value);
    setTimeout(() => {
      setmessage("");
    }, 3000);
  };

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  async function checkFileExists(filePath) {
    try {
      await getDownloadURL(filePath);
      return true;
    } catch (error) {
      if (error.code === "storage/object-not-found") {
        return false;
      }
    }
  }

  const [fileUrll, setFileUrl] = useState(null);
  const fileLink = async () => {
    const fileNames = {
      0: "gross",
      1: "Income from Rent sources",
      2: "80C",
      3: "Income from other sources",
      4: "80C",
      5: "80CCD",
      6: "80D",
      7: "80DD",
      8: "80DDB",
      9: "80G",
      10: "80GG",
      11: "OtherEmp",
      12: "costTourAllowance",
      13: "childEduAllowance",
      14: "rentAllowance",
      15: "travelAllowance", // Fixed: consistent naming
      16: "otherAllowance",
      17: "HomeLoan",
      18: "80U",
      19: "80tta",
    };
    const id = Number(questID);

    if (isNBSP) {
      const storageRef1 = ref(
        storage,
        `userDocs/AY-${year}/${pan.toUpperCase()}`
      );
      const storageRef = ref(
        storage,
        `userDocs/AY-${year}/${pan.toUpperCase()}`
      );

      checkFileExists(storageRef1)
        .then(async (exists) => {
          if (exists) {
            const fileUrl1 = await getDownloadURL(storageRef1);
            setNBSPURL0(fileUrl1);
          }
        })
        .catch((error) => {
          console.error("Error checking file:", error);
        });

      checkFileExists(storageRef)
        .then(async (exists) => {
          if (exists) {
            const fileUrl = await getDownloadURL(storageRef);
            setNBSPURL1(fileUrl);
          }
        })
        .catch((error) => {
          console.error("Error checking file:", error);
        });
    } else {
      const fileName = fileNames[id];
      if (fileName) {
        const storageRef = ref(
          storage,
          `userDocs/AY-${year}/${pan.toUpperCase()}/${fileName}`
        );

        checkFileExists(storageRef)
          .then(async (exists) => {
            if (exists) {
              const fileUrl = await getDownloadURL(storageRef);
              setFileUrl(fileUrl);
            }
          })
          .catch((error) => {
            console.error("Error checking file:", error);
          });
      }
    }
  };

  useEffect(() => {
    if (pan) {
      fileLink();
    }
  }, [pan, questID]);

  useEffect(() => {
    setPan(getPan(auth.currentUser?.email));
  }, [auth.currentUser?.email]);

  // Modified handleSubmit function to show success message
  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit();
      newmessage("Details entered successfully");
    }
  };

  // Enhanced input change handler for better number formatting
  const handleInputChange = (index, inputValue) => {
    let temp = [...value];
    temp[index] = inputValue;

    // Remove commas and validate if it's a number
    let cleanValue = inputValue.split(",").join("");

    if (cleanValue === "" || (!isNaN(cleanValue) && !isNaN(parseFloat(cleanValue)))) {
      if (cleanValue !== "" && !isNaN(parseFloat(cleanValue))) {
        // Format with Indian number system
        let formattedValue = parseFloat(cleanValue).toLocaleString("en-IN");
        temp[index] = formattedValue;
      } else {
        temp[index] = cleanValue;
      }
      setValue(temp);
    }
  };

  return (
    <div className="question" style={{ flexDirection: "column" }}>
      {message && (
        <div className="alert alert-success quest-alert" style={{ margin: 0 }}>
          {message}
        </div>
      )}

      <div className="question-content px-2" style={{ maxWidth: "600px" }}>
        {question.map((item, index) => (
          <h3 key={index} className="m-2 mb-4">
            {item}
          </h3>
        ))}

        {limit && (
          <div style={{ color: "red", fontWeight: "bold", marginBottom: "10px" }}>
            {limit}
          </div>
        )}

        {suggestion && (
          <div className="suggestion">
            <button
              onClick={() => {
                newmessage("Great, now enter the amount in the respective box");
              }}
            >
              {t("Yes")}
            </button>
            <button
              onClick={() => {
                handleSubmit();
              }}
            >
              {t("No")}
            </button>
          </div>
        )}

        <div className="d-flex justify-content-center align-items-center flex-column">
          {showUpload && (
            <>
              <div className="mb-3">
                <BiImageAdd
                  size={50}
                  onClick={togglePopup}
                  style={{ cursor: "pointer" }}
                />
                {uploadedFileUrl && (
                  <div className="mt-2">
                    <a
                      href={uploadedFileUrl}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        fontSize: "1.2rem",
                        color: "#007bff",
                        textDecoration: "underline",
                        display: "block",
                        marginTop: "10px"
                      }}
                      onMouseOver={(e) => (e.currentTarget.style.color = "#0056b3")}
                      onMouseOut={(e) => (e.currentTarget.style.color = "#007bff")}
                    >
                      📄 Preview Uploaded File
                    </a>
                  </div>
                )}
              </div>

              <Modal
                isOpen={isPopupOpen}
                onRequestClose={togglePopup}
                contentLabel="Upload Popup"
                style={{
                  content: {
                    borderRadius: "10px",
                    width: "70%",
                    height: "50vh",
                    margin: "auto",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -70%)",
                  },
                }}
              >
                <div className="modal-content">
                  <h2 className="modal-title">Upload File</h2>
                  <div className="modal-body d-flex flex-column">
                    <div className="mb-4">
                      <input
                        className="form-control"
                        type="file"
                        id="formFile"
                        onChange={handleFileChange}
                        accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                      />
                      <small className="text-muted">
                        Supported formats: PDF, JPG, PNG, DOC, DOCX
                      </small>
                    </div>
                    <div className="button-group d-flex gap-3">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleFileUpload}
                        disabled={isLoading || !selectedFile}
                      >
                        {isLoading ? "Uploading..." : "Upload"}
                      </button>
                      <button
                        className="cancel-button btn btn-secondary"
                        onClick={togglePopup}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </Modal>
            </>
          )}

          {dropdown && (
            <div className="dropdown mb-3">
              <label className="fw-semibold" htmlFor={dropdown.label}>
                {dropdown.label}
              </label>
              <select
                className="form-select p-2 rounded m-2"
                id={dropdown.label}
                value={dropdown.value}
                onChange={(e) => dropdown.onChange(e.target.value)}
              >
                <option value="">Select an option</option>
                {dropdown.options.map((option, index) => (
                  <option key={index} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          )}

          {!radio && Array.isArray(value) &&
            value.map((item, index) => (
              <input
                key={index}
                className="form-control my-2"
                type="text"
                value={item}
                placeholder={label[index] || `Enter amount ${index + 1}`}
                autoFocus={index === 0}
                onChange={(e) => handleInputChange(index, e.target.value)}
              />
            ))}

          {radio && (
            <div className="radio-questions">
              {options.map((item, index) => (
                <label key={index} className="d-block mb-2">
                  <input
                    className="me-2"
                    type="radio"
                    name={question[0]}
                    value={index}
                    onClick={() => {
                      setValue([index]);
                    }}
                    defaultChecked={index === value}
                  />
                  {item}
                </label>
              ))}
            </div>
          )}

          {onAnswer && (
            <button
              className="btn btn-next btn-primary m-2"
              onClick={onAnswer}
              disabled={loading}
            >
              {t("Next")}
            </button>
          )}
        </div>

        {onSubmit && (
          <button
            disabled={loading}
            className="btn btn-next btn-primary m-2"
            onClick={handleSubmit}
          >
            {loading ? "Loading..." : "Submit"}
          </button>
        )}

        {onPrev && (
          <button className="btn btn-next btn-primary m-2" onClick={onPrev}>
            Previous
          </button>
        )}
      </div>
    </div>
  );
};

export default Question;